<template>
  <div class="account-settings-info-view">
    <a-row :gutter="16">
      <a-col :md="24" :lg="16">

        <a-form layout="vertical" :form="form">
          <a-form-item
            label="用户Id"
          >
            <a-input :disabled="true" v-decorator="['userId']"/>
          </a-form-item>
          <a-form-item
            label="用户名"
          >
            <a-input :disabled="true" v-decorator="['username']"/>
          </a-form-item>
          <!--          <a-form-item-->
          <!--            label="昵称"-->
          <!--          >-->
          <!--            <a-input placeholder="给自己起个名字" />-->
          <!--          </a-form-item>-->
          <a-form-item
            label="登录密码"
            :required="false"
          >
            <a-input v-decorator="['password']" placeholder="不修改留空"/>
          </a-form-item>
          <a-form-item
            label="新登录密码"
            :required="false"
          >
            <a-input v-decorator="['newpassword1']" placeholder="不修改留空"/>
          </a-form-item>
          <a-form-item
            label="手机号"
            :required="false"
          >
            <a-input v-decorator="['phone']"/>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="update">提交</a-button>
            <a-button style="margin-left: 8px" @click="goBack">返回</a-button>
          </a-form-item>
        </a-form>

      </a-col>
      <a-col :md="24" :lg="8" :style="{ minHeight: '180px' }">
        <!--        暂时隐藏头像-->
        <!--        <div class="ant-upload-preview" @click="$refs.modal.edit(1)" >-->
        <!--          <a-icon type="cloud-upload-o" class="upload-icon"/>-->
        <!--          <div class="mask">-->
        <!--            <a-icon type="plus" />-->
        <!--          </div>-->
        <!--          <img :src="option.img"/>-->
        <!--        </div>-->
      </a-col>
    </a-row>
    <!--    <avatar-modal ref="modal" @ok="setavatar"/>-->
  </div>
</template>

<script>
import AvatarModal from './AvatarModal'
import { getInfo } from '@api/login'
import { edit } from '@api/sys/user'
import { mapActions } from 'vuex'
import pick from 'lodash.pick'

export default {
  components: {
    AvatarModal
  },
  data () {
    return {
      // cropper
      preview: {},
      form: this.$form.createForm(this),
      option: {
        img: '/avatar2.jpg',
        info: true,
        size: 1,
        outputType: 'jpeg',
        canScale: false,
        autoCrop: true,
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 180,
        autoCropHeight: 180,
        fixedBox: true,
        // 开启宽度和高度比例
        fixed: true,
        fixedNumber: [1, 1]
      },
      userInfo: {
        userId: '',
        username: '',
        password: '',
        avatar: '',
        phone: ''
      },
      avatar: ''
    }
  },
  methods: {
    ...mapActions(['Logout']),
    init () {
      getInfo().then(res => {
        this.userInfo = res.data.sysUser
        const { form: { setFieldsValue } } = this
        setFieldsValue(pick(this.userInfo, ['userId', 'username', 'phone']))
      })
    },
    setavatar (url) {
      this.option.img = url
    },
    goBack () {
      this.$router.push({ path: '/' })
    },
    update () {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          edit({
            ...values
          }).then(res => {
            this.$message.success('修改成功,请重新登录！')
            this.form.setFieldsValue({ newpassword1: undefined })
            this.quite()
          }).catch(err => {
            this.$message.error(err.msg)
          })
        } else {
          this.$message.info('新密码和旧密码必须同时填写!')
        }
      })
    },
    // 修改成功后,自动退出重新登陆
    quite () {
      this.Logout({}).then(() => {
        window.location.reload()
      }).catch(err => {
        this.$message.error({
          title: '错误',
          description: err.message
        })
      })
    }
  },
  created () {
    this.init()
  }
}
</script>

<style lang="less" scoped>

  .avatar-upload-wrapper {
    height: 200px;
    width: 100%;
  }

  .ant-upload-preview {
    position: relative;
    margin: 0 auto;
    width: 100%;
    max-width: 180px;
    border-radius: 50%;
    box-shadow: 0 0 4px #ccc;

    .upload-icon {
      position: absolute;
      top: 0;
      right: 10px;
      font-size: 1.4rem;
      padding: 0.5rem;
      background: rgba(222, 221, 221, 0.7);
      border-radius: 50%;
      border: 1px solid rgba(0, 0, 0, 0.2);
    }
    .mask {
      opacity: 0;
      position: absolute;
      background: rgba(0,0,0,0.4);
      cursor: pointer;
      transition: opacity 0.4s;

      &:hover {
        opacity: 1;
      }

      i {
        font-size: 2rem;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -1rem;
        margin-top: -1rem;
        color: #d6d6d6;
      }
    }

    img, .mask {
      width: 100%;
      max-width: 180px;
      height: 100%;
      border-radius: 50%;
      overflow: hidden;
    }
  }
</style>
